import { ApiCancelToken } from 'api';
import { del, get, post, put } from 'features/api';
import { CompareListRequest, CompareListStatus, ProductCompareData, CompareListsFromAPI } from './types';

export const getLists = (customerId: string, customHost: string, cancelToken?: ApiCancelToken) => {
  return get<CompareListsFromAPI>(
    'lists',
    { customerId },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      cancelToken,
    },
    customHost,
  );
};

export const createList = (body: CompareListRequest, customHost: string, cancelToken?: ApiCancelToken) => {
  return post<CompareListStatus>(
    'list',
    body,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      cancelToken,
    },
    undefined,
    customHost,
  );
};

export const putList = (body: CompareListRequest, customHost: string, cancelToken?: ApiCancelToken) => {
  return put<CompareListStatus>(
    'list',
    body,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      cancelToken,
    },
    customHost,
  );
};

export const deleteList = (
  customerId: string,
  groupId: string,
  customHost: string,
  cancelToken?: ApiCancelToken,
) => {
  return del<CompareListStatus>(
    'list',
    { customerId, groupId },
    {
      cancelToken,
    },
    customHost,
  );
};

export const getCompareData = (
  customerId: string,
  groupId: string,
  regionCode: string,
  customHost: string,
  cancelToken?: ApiCancelToken,
) => {
  return post<ProductCompareData>(
    'compare',
    { customerId, groupId, regionCode },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      cancelToken,
    },
    undefined,
    customHost,
  );
};
